import axios from 'axios';

const ENGLISH_ERROR_HINTS: Array<[RegExp, string]> = [
  [/string should have at least 1 character/i, 'Поле не должно быть пустым'],
  [/string should have at least (\d+) characters?/i, 'Поле должно содержать не меньше $1 символов'],
  [/string should have at most (\d+) characters?/i, 'Поле должно содержать не больше $1 символов'],
  [/input should be a valid integer/i, 'Ожидалось целое число'],
  [/input should be a valid number/i, 'Ожидалось число'],
  [/input should be a valid date/i, 'Некорректная дата'],
  [/field required/i, 'Обязательное поле'],
  [/value is not a valid enumeration member/i, 'Недопустимое значение'],
  [/ensure this value is greater than/i, 'Значение слишком маленькое'],
  [/ensure this value is greater than or equal to/i, 'Значение слишком маленькое'],
  [/ensure this value is less than/i, 'Значение слишком большое'],
  [/ensure this value is less than or equal to/i, 'Значение слишком большое'],
];

function localizeMessage(message: string): string {
  const trimmed = message.trim();
  for (const [pattern, replacement] of ENGLISH_ERROR_HINTS) {
    if (pattern.test(trimmed)) {
      return trimmed.replace(pattern, replacement);
    }
  }
  return trimmed;
}

/** Достаёт текст ошибки из ответа API / Axios. */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error)) {
    const detail = error.response?.data?.detail;
    if (typeof detail === 'string' && detail.trim()) {
      return localizeMessage(detail);
    }
    if (Array.isArray(detail) && detail[0]?.msg) {
      return localizeMessage(String(detail[0].msg));
    }
  }
  if (error instanceof Error && error.message) {
    return localizeMessage(error.message);
  }
  return fallback;
}
